import React, { useEffect, useState } from 'react';
import db from "../../../../api/mongodb";
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardActionArea, CardContent, Container, Grid } from '@mui/material';
import { Button } from 'react-bootstrap';


const BestPracticeList = () => {

    const [bestPracticeList, setBestPracticeList] = useState([])

    const navigate = useNavigate()

    useEffect(() => {
        db.get("/api/bestPractices/getAll")
            .then((data) => {

                setBestPracticeList(data.data)
                // console.log(data.data)
            })
            .catch((err) => {
                navigate("/projects/active")

            })
    }, [])

    return (
        <Container>
            {
                bestPracticeList.length > 0 ?
                    bestPracticeList.map((bestPractice) =>
                        <Card sx={{ marginTop: "20px" }} key={bestPractice._id}>
                            <CardContent>
                                <h4>
                                    {bestPractice.formData.name}
                                </h4>
                                {bestPractice.formData.description}
                                <br/>
                                <br/>
                                <Link to={`/createBestPractice/${bestPractice._id}`}>
                                    <Button className="btn-primary">Edit</Button>
                                </Link>
                                &nbsp;&nbsp;
                                <Link target="_blank" rel="noopener noreferrer" to={`/bestPractice/${bestPractice._id}`}>
                                    <Button className="btn-primary">View</Button>
                                </Link>
                            </CardContent>
                            
                                
                            
                        </Card>
                    )
                    :
                    "Loading..."
            }

        </Container>
    );
};

export default BestPracticeList;